/* eslint-disable @typescript-eslint/no-redeclare */
/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import { Bizo, autoclass } from './base'
import type { DetailLink as DetailLinkType, RawDetailLink } from './detailLinks.types'

export const DetailLink = autoclass<DetailLinkType, RawDetailLink>(
  'DetailLink',
  class GlobalNavLinks extends Bizo<DetailLinkType, RawDetailLink> {},
  {
    displayText: 'display_text',
    listingCount: 'listing_count', // TODO: does this field exist? I don't see it on BE / in API responses
    url: 'url',
  }
)

export type DetailLink = DetailLinkType

export const DetailLinks = {
  fromJS: (data: readonly RawDetailLink[] | null | undefined): readonly DetailLink[] => {
    if (data) {
      if (Array.isArray(data)) {
        return data.map((link: RawDetailLink) => DetailLink.fromJS(link))
      }
    }
    return []
  },
}
